export const SCHOOL_FEATURE_SWITCHES = {
  MONSTERVERSE_SCHOOL_SEASONAL_OPT_OUT: "monsterverseSeasonalUpdatesOptOut",
  MONSTERVERSE_GATHER: "monsterverseGatherLoopV2",
};

export const USER_FEATURE_SWITCHES = {};

export const CLASSROOM_FEATURE_SWITCHES = {};

export const FEATURE_SWITCHES = {
  ...USER_FEATURE_SWITCHES,
  ...SCHOOL_FEATURE_SWITCHES,
  ...CLASSROOM_FEATURE_SWITCHES,
};
